import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '../../ui/core';

// Like the shared ConfirmModal, but carries an OPTIONAL removedNote field —
// the reason an exclusion is being lifted. Its own component (not ConfirmModal)
// so tests can stub it and drive onConfirm(removedNote)/onCancel directly, the
// same way the throttling tables stub ConfirmModal.
const RemoveExclusionDialog = ({ open, submitting, onConfirm, onCancel }) => {
  const [removedNote, setRemovedNote] = useState('');

  // Reset the field each time the dialog opens so a note typed for one removal
  // never leaks into the next.
  useEffect(() => {
    if (open) setRemovedNote('');
  }, [open]);

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Remove exclusion</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: '16px' }}>
          Removing lets this rider and driver be matched again. This is a soft-remove — the entry stays in history.
        </Typography>
        <TextField
          fullWidth
          label="Removal note"
          value={removedNote}
          onChange={(event) => setRemovedNote(event.target.value)}
          inputProps={{ 'aria-label': 'Removal note', maxLength: 500 }}
          helperText="Optional"
        />
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button onClick={onCancel} variant="outlined" disabled={!!submitting}>
          Cancel
        </Button>
        <Button
          onClick={() => onConfirm(removedNote.trim() ? removedNote.trim() : undefined)}
          variant="contained"
          color="error"
          disabled={!!submitting}
          disableElevation
        >
          {submitting ? 'Removing…' : 'Remove exclusion'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveExclusionDialog;
